// import React, { useEffect, useState } from 'react'
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// export default function TextareaHandler({form_data, setFormData, Name='textarea', Type="", Label="",  ClassName='custom-editor'}) {
//     return (
//         <div className={ClassName}>
//             <label class="form-label">{Label}</label>
//             <CKEditor
//                 editor={ClassicEditor}
//                 data={form_data[Name]}
//                 onReady={editor => {
//                     console.log('Editor is ready to use!', editor);
//                 }}
//                 onChange={(event, editor) => {
//                     const data = editor.getData().replace(/(["'])/g, "&quot;");
//                     setFormData({...form_data, [Name]: data})
//                     // setContent(data);
//                     console.log({ event, editor, data });
//                 }}
//                 onBlur={(event, editor) => {
//                     console.log('Blur.', editor);
//                 }}
//                 onFocus={(event, editor) => {
//                     console.log('Focus.', editor);
//                 }}
//             />
//         </div>
//     );
// }




// import React, { useEffect, useState } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// export default function TextareaHandler({
//     form_data,
//     setFormData,
//     Name = 'textarea',
//     Type = '',
//     Label = '',
//     ClassName = 'custom-editor',
// }) {
//     const [editorLoaded, setEditorLoaded] = useState(false);

//     // Ensure CKEditor re-renders correctly when switching forms (especially in edit)
//     useEffect(() => {
//         setEditorLoaded(true);
//     }, [Name, form_data[Name]]);

//     return (
//         <div className={ClassName}>
//             {Label && <label className="form-label">{Label}</label>}
//             {editorLoaded && (
//                 <CKEditor
//                     key={Name} // Ensures re-initialization on name change
//                     editor={ClassicEditor}
//                     data={form_data[Name] || ''}
//                     config={
//                         //     {
//                         //     toolbar: [
//                         //       'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList',
//                         //       '|', 'blockQuote', 'undo', 'redo', 'imageUpload',
//                         //     ]
//                         //   }
//                         {
//                             toolbar: [
//                                 'undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript', '|',
//                                 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor', '|', 'blockQuote', 'insertTable', 'imageUpload',
//                                 'mediaEmbed', 'link', '|', 'htmlEmbed', 'codeBlock', 'SourceEditing', '|', 'strikethrough', 'subscript',
//                                 'superscript', 'code', 'numberedList', 'bulletedList', 'todoList', 'outdent', 'indent'
//                             ],
//                             image: {
//                                 toolbar: ['imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight'],
//                             },
//                             table: {
//                                 contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
//                             },
//                         }
//                     }
//                     onReady={editor => {
//                         console.log('Editor is ready to use!', editor);
//                     }}
//                     onChange={(event, editor) => {
//                         const data = editor.getData();
//                         setFormData(prev => ({
//                             ...prev,
//                             [Name]: data,
//                         }));
//                     }}
//                     onBlur={(event, editor) => {
//                         console.log('Blur.', editor);
//                     }}
//                     onFocus={(event, editor) => {
//                         console.log('Focus.', editor);
//                     }}
//                 />
//             )}
//         </div>
//     );
// }










import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Add font sizes in px
const Size = ReactQuill.Quill.import('formats/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '30px', '36px', '48px'];
ReactQuill.Quill.register(Size, true);

export default function TextareaHandler({
    form_data,
    setFormData,
    Name = 'textarea',
    Label = '',
    ClassName = 'custom-editor'
}) {
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(form_data?.[Name] || '');
    }, [form_data, Name]);

    const handleChange = (content) => {
        console.log(content);
        setValue(content);
        setFormData((prev) => ({
            ...prev,
            [Name]: content
        }));
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            [{ 'size': Size.whitelist }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['blockquote', 'code-block'],
            ['link', 'image'],
            ['clean']
        ]
    };

    const formats = [
        'header',
        'size',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'blockquote', 'code-block',
        'link', 'image'
    ];

    return (
        <div className={ClassName}>
            {Label && <label className="form-label">{Label}</label>}
            <ReactQuill
                theme="snow"
                value={value}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                style={{ minHeight: '180px' }}
            />
        </div>
    );
}


